export default __webpack_public_path__ + "static/media/help-desk-10.dd25c1f5.png";